export default "__VITE_ASSET__neseYoxW__"